/**
 * 詳細パラメータ表示の基本機能
 */
<script >
export default {
	mixins: [
		// 詳細画面パラメータの共通機能
		require('js/common/vuex/manager/read.mixin.vue'),
		require('js/common/url.mixin.vue'),
	],
	props: [
		'r_class_code',
		'r_code',
		'r_code2',
		'r_code2_name',
		'r_src',
		'r_info',
		'r_is_new',
		'r_settings',
		'r_messages',
		'r_type',
		'r_type_maincode',	// メインコードが特殊な場合に使用
	],
	data: function (){
		return{
			m_info: null,
			m_bCodeEnable: false,
			m_isNetwork:true,
			m_type: this.r_type?this.r_type:0,
			m_editdataClick: false,
			m_bErrDetailDisp: false,
		}
	},
	created: function() {
//		this.checkCode();
	},
	computed: {
		code_max: function(){
			var codeMax = 999999;
			var codes;
			var tmpType = this.m_type;
			if (this.r_type_maincode) {
				tmpType = this.r_type_maincode;
			}
			codes = this.manager.getMaxMinCodes(tmpType);
			if ( codes == null ) {
				return codeMax;
			}
			return codes.max;	
		},
		code_min: function(){
			var codeMin = 1;
			var codes;
			var tmpType = this.m_type;
			if (this.r_type_maincode) {
				tmpType = this.r_type_maincode;
			}
			codes = this.manager.getMaxMinCodes(tmpType);
			if ( codes == null ) {
				return codeMin;
			}
			return codes.min;
		},
		code2_max: function(){
		},
		code2_min: function(){
		},
		/**
		 * コード有効判定
		 */
		is_code_enable: function(){
			var temp = this.r_code + "";
			if( temp.length == 0 ||
				Number(this.r_code) > Number(this.code_max) || 
				Number(this.r_code) < Number(this.code_min)){
				return false;
			}
			return true;
		},
		/**
		 * コード有効判定
		 */
		is_code2_enable: function(){
			var temp = this.r_code2 + "";
			if( temp.length == 0 ||
				Number(this.r_code2) < Number(this.code_min)){
				return false;
			}
			return true;
		},
		//! 確定ボタン有効判定
		is_confirm_enable: function(){
			if (!this.m_bCodeEnable) {
				// コードが入力されていない
				return false;
			}
			if (!this.m_isNetwork) {
				// ネットワークが有効でない
				return false;
			}
			return true;
		},
		//! コピーボタン有効判定
		is_copy_enable: function(){
			if (this.r_is_new) {
				// 新規状態
				return false;
			}
			return this.is_confirm_enable;
		},
		//! 削除ボタン有効判定
		is_delete_enable: function(){
			if (this.r_is_new) {
				// 新規状態
				return false;
			}
			return this.is_confirm_enable;
		},
		//! 更新（リロード）ボタン有効判定
		is_restore_enable: function(){
			// @note コードの最小値が0の場合正常に動作しない
			if(this.is_code2_enable) {	// 枝番あり
				if ( !(this.r_code && this.r_code2) ) {
					// コードが存在しない
					return false;
				}
			}
			else {	// 枝番なし
				if ( !(this.r_code) ) {
					// コードが存在しない
					return false;
				}
			}
			return this.is_confirm_enable;
		},
		//! 新規追加ボタン有効判定
		is_disp_new_btn: function(){
			return !this.is_confirm_enable;
		},
		//! 変更ボタン有効判定
		is_disp_edit_btn: function(){
			return !this.is_confirm_enable;
		},
		//! コピーボタン有効判定
		is_disp_copy_btn: function(){
			return this.is_confirm_enable;
		},
		//! 変更ボタン有効判定
		is_disp_delete_btn: function(){
			return this.is_confirm_enable;
		},
		// エラー詳細ボタン表示判定
		is_disp_errdetail_btn: function(){
			return this.m_bErrDetailDisp;
		},
		//! 新規追加によりCodeが生成されるか？
		is_update_create_code:function(){
			return false;
		},
	},
	watch:{
		is_confirm_enable: function(){
			this.$emit("event_state_change");
		},
		is_copy_enable: function(){
			this.$emit("event_state_change");
		},
		is_delete_enable: function(){
			this.$emit("event_state_change");
		},
		is_restore_enable: function(){
			this.$emit("event_state_change");
		},
		is_disp_copy_btn: function(){
			this.$emit("event_state_change");
		},
		is_disp_delete_btn: function(){
			this.$emit("event_state_change");
		},
		is_disp_errdetail_btn : function(){
			this.$emit("event_state_change");
		},
		r_code: function(){
			this.checkCode();
		},
		r_type: function(val){
			this.m_type = this.r_type;
		},
	},
	methods: {
		/**
		 * 更新
		 */
		update: function( update_type,info,  extra ){
			return this.sendUpdate(update_type,this.convertUpdateData(info) , extra);
		},
		/**
		 * 再取得
		 */
		refresh: function(){
			return this.sendRefresh(this.r_code,this.r_code2);
		},
		/**
		 * アイテム変更
		 */
		changeItem: function(code,code2){
			this.checkCode();
			return this.sendRefresh(code,code2);
		},
		/**
		 * アイテム編集
		 */
		editItem: function(code,code2){
			this.checkCode();
			this.m_editdataClick = true;
			return this.sendRefresh(code,code2);
		},
		/**
		 * 初期化データを返す
		 */
		reset: function(param){
			return this.getResetData(param);
		},
		/**
		 * コピーアイテムを作成 
		 * (詰めなおしを行う場合はこの関数をオーバーライドする。)
		 */
		copyItem: function(itemNew, itemSrc){
			var info = $.extend(true,{},itemNew);
			// コピーアイテムフラグを追加
			info["isCopy"] = true;
			info.update_timestamp = itemSrc.update_timestamp;
			if(itemSrc.depart_code !== undefined){
				info.depart_code = itemSrc.depart_code;
			}
			return info;
		},
		//! info から code を取得する処理 for override
		convertInitCode : function(info){ return 0;},
		//! info から code2 を取得する処理 for override
		convertInitCode2 : function(info){return 0;},
		//! 消去時のデータリセット処理 オーバーライド化
		resetCode : function(code){ return "";},
		//! 消去時のデータリセット処理 オーバーライド化
		resetCode2 : function(code2){ return "";},
		//! ビュー状態変更イベント
		onViewStateChange: function(info,extra){
			this.checkCode();
		},
		/**
		 * 初期データ用の変換データを取得
		 */
		convertInitData: function(info){
			return $.extend(true,{},info);
		},
		/**
		 * 更新用のデータを取得
		 */
		convertUpdateData: function(info){
			return info;
		},
		/**
		 * コピーデータ用の変換データを取得
		 */
		convertCopyData: function(info){
			return $.extend(true,{},info);
		},
		// コードが正しくセットされているかチェック
		checkCode: function(){
			var temp = this.r_code + "";

			if( temp.length == 0 ||
				Number(this.r_code) > Number(this.code_max) || 
				Number(this.r_code) < Number(this.code_min)){
				this.m_bCodeEnable=false;
			}else
			{
				this.m_bCodeEnable=true;
			}
		},
		getResetData : function(param){
			var data = {};
			for(var key in this.r_info){
				switch(typeof( this.r_info[key]))
				{
				case "string":
					data[key]="";
					break;
				case "number":
					data[key]=0;
					break;
				default:
					data[key]=null;
					break;
				}
			}
			if(param){
				for( var key in param)
				{
					data[key] = param[key];
				}
			}
			return data;
		},
		/**
		 * 更新リクエスト送信
		 */
		sendRefresh: function(code , code2){
			if(!code){// 必須
				return false;
			}

			var url ="";
			url =  this.manager.createRefreshURL(this.r_class_code,
														code,
														code2,
														this.r_type);
				
			var target = this;
			var callbackOK = function(rResponse){
				target.m_isNetwork = true;
				var data = target.convertRefreshResponseSub(rResponse);
				target.$emit("event_refresh_end",0,data, null);
			}
			var callbackNG = function(rResponse){
				target.m_isNetwork = +rResponse.data["result"]==target.manager.ERR_CODE?false:true;
				target.$emit("event_refresh_end",1, rResponse, rResponse.data.errmessage);
			}
			this.manager.access(url,callbackOK,callbackNG);
			return true;
		},
		/**
		 * 前へボタンイベント
		 */
		changeItemPrevious: function(code,code2){
			this.checkCode();
			return this.sendNextRefresh(code,code2,-1);
		},
		/**
		 * 次へボタンイベント
		 */
		changeItemNext: function(code,code2){
			this.checkCode();
			return this.sendNextRefresh(code,code2,1);
		},
		/**
		 * 前次リクエスト送信
		 */
		sendNextRefresh: function(code,code2,isNext){
			var url ="";
			url =  this.manager.createNextURL(this.r_class_code,code,code2,isNext,this.r_type);
				
			var target = this;
			var callbackOK = function(rResponse){
				target.m_isNetwork = true;
				if (rResponse.data.allcount > 0) {
					var data = target.convertRefreshResponseSub(rResponse);
					target.$emit("event_next_refresh_end",0,data, null);
				} else {
					target.$emit("event_next_refresh_end",1, rResponse, rResponse.data.errmessage);
				}
			}
			var callbackNG = function(rResponse){
				target.m_isNetwork = rResponse.data["result"]==target.manager.ERR_CODE?false:true;
				target.$emit("event_refresh_end",1, rResponse, rResponse.data.errmessage);
			}
			this.manager.access(url,callbackOK,callbackNG);
			return true;

		},
		convertRefreshResponseSub:function(res){
			return this.manager.convertRefreshResponse(res,this.r_type);
		},
		//! 更新レスポンスによるコードの更新
		convertUpdateCode:function(res){
			return 0;
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/common/funcDetailBase2.mixin.vue